// import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import * as VueRouter from "vue-router";
import { NO_USER_INFO_PATH_NAME } from "../../src/view/no-user-info/constants";
import { NEED_CHECK_PAYLOAD_PATHNAME } from "../../src/view/need-check-payload/constants";
import { INNER_MINI_PROGRAM_PATHNAME } from "../../src/view/inner-mini-program/constants";
const getNeedCheckPayloadComponent = () =>
  import("../view/need-check-payload/index.vue");
const getNoUserInfoComponent = () => import("../view/no-user-info/index.vue");
const getInnerMiniProgramComponent = () =>
  import("../view/inner-mini-program/index.vue");
export const routes = [
  {
    path: `/${NO_USER_INFO_PATH_NAME.Shenzhen}`,
    name: NO_USER_INFO_PATH_NAME.Shenzhen,
    meta: {
      title: "权益领取",
    },
    component: getNoUserInfoComponent,
  },
  {
    path: `/${NO_USER_INFO_PATH_NAME.XuepingxianDraw}`,
    name: NO_USER_INFO_PATH_NAME.XuepingxianDraw,
    meta: {
      title: "权益领取",
    },
    component: getNoUserInfoComponent,
  },
  {
    path: `/${NO_USER_INFO_PATH_NAME.Meizhou}`,
    name: NO_USER_INFO_PATH_NAME.Meizhou,
    meta: {
      btnColor: "linear-gradient(187deg, #FFC053 -3%, #F15555 117%)",
      title: "权益领取",
    },
    component: getNoUserInfoComponent,
  },
  {
    path: "/chenxi",
    name: "chenxi",
    meta: {
      title: "权益领取",
    },
    component: () => import("../view/chenxi/index.vue"),
  },
  {
    path: `/${NEED_CHECK_PAYLOAD_PATHNAME.Suzhou}`,
    name: NEED_CHECK_PAYLOAD_PATHNAME.Suzhou,
    meta: {
      title: "权益领取",
    },
    component: getNeedCheckPayloadComponent,
  },
  {
    path: `/${NEED_CHECK_PAYLOAD_PATHNAME.Xuepingxian}`,
    name: NEED_CHECK_PAYLOAD_PATHNAME.Xuepingxian,
    meta: {
      title: "权益领取",
    },
    component: getNeedCheckPayloadComponent,
  },
  {
    path: `/${NEED_CHECK_PAYLOAD_PATHNAME.Xiaoyaoxiang}`,
    name: NEED_CHECK_PAYLOAD_PATHNAME.Xiaoyaoxiang,
    meta: {
      title: "权益领取",
    },
    component: getNeedCheckPayloadComponent,
  },
  {
    path: `/${NEED_CHECK_PAYLOAD_PATHNAME.Hangzhou}`,
    name: NEED_CHECK_PAYLOAD_PATHNAME.Hangzhou,
    meta: {
      title: "权益领取",
    },
    component: getNeedCheckPayloadComponent,
  },
  {
    path: `/${INNER_MINI_PROGRAM_PATHNAME.Xiaoyaoxiang}`,
    name: INNER_MINI_PROGRAM_PATHNAME.Xiaoyaoxiang,
    meta: {
      title: "权益领取",
    },
    component: getInnerMiniProgramComponent,
  },
  {
    path: `/shaoxing`,
    name: "shaoxing",
    meta: {
      title: "权益领取",
    },
    component: () => import("../view/shaoxing/index.vue"),
  },
  {
    path: "/tianjin",
    name: "tianjin",
    meta: {
      title: "权益领取",
    },
    component: () => import("../view/tianjin/index.vue"),
  },
  {
    path: "/jiangmen",
    name: "jiangmen",
    meta: {
      title: "权益领取",
    },
    component: () => import("../view/jiangmen/index.vue"),
  },
  {
    path: "/songjian",
    name: "songjian",
    meta: {
      title: "机构注册",
    },
    component: () => import("../view/songjian/index.vue"),
  },
  {
    path: "/foshan",
    name: "foshan",
    meta: {
      title: "领取权益",
    },
    component: () => import("../view/foshan/index.vue"),
  },
  {
    path: "/prev-doc",
    name: "prev-doc",
    meta: {
      title: "手册",
    },
    component: () => import("../view/prev-doc/index.vue"),
  },
];

const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  routes,
});

export default router;
